import theme, { ThemeColorsKeysType, ThemeColorsLightKeysType, ThemeColorsShadesNeutral } from '../../Core/Styles/theme'
import styled, { css } from 'styled-components'

const BREAKPOINT = '1550px'

export interface GridProps {
  gridTemplateColumns?: string;
  responsiveGridTemplateColumns?: string;
  marginLeft?: string;
  marginBottom?: string;
  marginTop?: string;
  gridAutoFlow?: 'row' | 'column' | 'row dense' | 'column dense';
  gridTemplateRows?: string;
  gridTemplateAreas?: string;
  alignContent?: 'flex-start' | 'flex-end' | 'center' | 'space-around' | 'space-evenly' | 'space-between';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'start' | 'end' | 'stretch';
  rowGap?: string;
  gridGap?: string;
  padding?: string;
  boxSizing?: string;
  border?: string;
  topBorder?: string;
  borderRadius?: string;
  backgroundColor?: ThemeColorsKeysType | ThemeColorsLightKeysType | ThemeColorsShadesNeutral;
  width?: string;
}

const findNeutral = (neutralColor: string) => {
  const neutralIndex = parseInt(neutralColor?.split('-')?.[1])
  return theme.colors.shades.neutral[`${neutralIndex}`]
}

const Grid = styled.div<GridProps>`
  width: ${props => props.width || '100%'};
  display: grid;
  grid-template-columns: ${props => props.gridTemplateColumns || '1fr'};
  ${props => props.responsiveGridTemplateColumns ?
    `@media (max-width: ${BREAKPOINT}) {
      grid-template-columns: ${props.responsiveGridTemplateColumns};
    }` :
    ''
}
  grid-template-rows: ${props => props.gridTemplateRows || 'auto'};
  grid-auto-flow: ${props => props.gridAutoFlow || 'row'};
  grid-gap: ${props => props.gridGap || '16px'};
  row-gap: ${props => props.rowGap || 'inherit'};
  margin-left: ${props => props.marginLeft || '0px'};
  margin-bottom: ${props => props.marginBottom || '0px'};
  margin-top: ${props => props.marginTop || '0px'};
  ${props =>
    props.gridTemplateAreas &&
    css`
      grid-template-areas: ${props.gridTemplateAreas};
    `}
  ${props =>
    props.alignContent &&
    css`
    align-content: ${props.alignContent};
  `}
  ${props =>
    props.alignItems &&
    css`
    align-items: ${props.alignItems};
  `}
  ${props =>
    props.padding &&
    css`
    padding: ${props.padding};
  `}
  ${props =>
    props.boxSizing &&
    css`
    box-sizing: ${props.boxSizing};
  `}
  ${props =>
    props.border &&
      css`
      border: ${props.border};
  `}
  ${props =>
    props.topBorder &&
      css`
      border-top: ${props.topBorder};
  `}
   ${props =>
    props.borderRadius &&
      css`
      border-radius: ${props.borderRadius};
  `}
  ${props =>
    props.backgroundColor &&
      css` background-color: ${props.backgroundColor.includes('neutral') ? findNeutral(props.backgroundColor) : theme.colors.main[props.backgroundColor as ThemeColorsKeysType | ThemeColorsLightKeysType]}`}
      `

export default Grid
